import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function About() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '36漫画网',
    url: 'https://36manhua.com',
    description: '专业的在线免费漫画阅读平台，提供洞洞杂货铺等海量优质漫画。',
    foundingDate: '2020',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@36manhua.com',
      availableLanguage: ['Chinese'],
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '洞洞杂货铺漫画是免费的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的！36漫画网上的洞洞杂货铺漫画完全免费阅读，无需付费订阅。我们致力于为漫画爱好者提供优质的免费阅读体验。',
        },
      },
      {
        '@type': 'Question',
        name: '漫画多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '洞洞杂货铺漫画保持每日更新，其他热门漫画也保持高频更新节奏。具体更新频率请关注各漫画的更新状态。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在36漫画网找到更多好看的漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过首页的热门推荐、分类浏览功能发现更多漫画。我们涵盖热血、恋爱、搞笑、悬疑、奇幻、都市、武侠、科幻等多种类型。',
        },
      },
      {
        '@type': 'Question',
        name: '阅读漫画需要注册账号吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '不需要！36漫画网所有漫画均可免注册直接阅读，无需登录即可畅享全部内容。',
        },
      },
      {
        '@type': 'Question',
        name: '漫画画质如何？阅读体验怎么样？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '36漫画网提供高清画质漫画，界面简洁、操作便捷。我们持续优化阅读体验，支持流畅的翻页和缩放功能，让您享受沉浸式追漫之旅。',
        },
      },
    ],
  };

  const pageSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 洞洞杂货铺漫画 - 36漫画网',
    description: '了解36漫画网品牌故事、平台口碑及联系方式。在线免费阅读洞洞杂货铺漫画的首选平台。',
    url: 'https://36manhua.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '36漫画网',
      url: 'https://36manhua.com',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(pageSchema) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="bg-background-100 border-b border-background-200/70">
            <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: '关于我们' },
                ]}
              />
              <h1 className="font-heading text-2xl md:text-3xl text-foreground-900 mt-4">
                关于我们
              </h1>
            </div>
          </div>

          <div className="max-w-4xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <section className="mb-14">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                  <i className="ri-building-4-line text-lg"></i>
                </div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-900">
                  品牌介绍
                </h2>
              </div>
              <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                <p>
                  <strong>36漫画网</strong>成立于2020年，是国内领先的在线免费漫画阅读平台。我们致力于为中文漫画爱好者提供最优质的阅读体验，让每一位读者都能在这里找到心仪的作品。
                </p>
                <p>
                  平台主打作品<strong>《洞洞杂货铺》</strong>自上线以来，凭借独特的奇幻世界观和温暖治愈的故事情节，迅速获得了广大读者的喜爱和好评。故事围绕城市角落里一家神秘的杂货铺展开，每件物品背后都藏着一个打动人心的故事。
                </p>
                <p>
                  除了洞洞杂货铺，我们还汇聚了热血、恋爱、搞笑、悬疑、奇幻、都市、武侠、科幻等八大类型的优质漫画。无论你喜欢什么风格，都能在36漫画网找到属于你的那部作品。
                </p>
                <p>
                  我们的团队由一群热爱漫画的年轻人组成，涵盖内容运营、技术开发、美术设计等专业人才。我们不断优化平台体验，确保每位读者都能享受流畅、高清、无广告干扰的沉浸式阅读。
                </p>
              </div>
            </section>

            <section className="mb-14">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-500">
                  <i className="ri-thumb-up-line text-lg"></i>
                </div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-900">
                  用户口碑
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="flex items-center gap-1 text-accent-500 mb-3">
                    {[1, 2, 3, 4, 5].map((i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                    "洞洞杂货铺是我今年看过最棒的漫画！每话都让人感动，画风也很精美。推荐给所有喜欢治愈系漫画的朋友！"
                  </p>
                  <p className="text-xs text-foreground-400">—— 漫画迷小王</p>
                </div>
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="flex items-center gap-1 text-accent-500 mb-3">
                    {[1, 2, 3, 4, 5].map((i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                    "36漫画网的界面真的很简洁，没有乱七八糟的广告。分类也很清晰，找漫画超方便！"
                  </p>
                  <p className="text-xs text-foreground-400">—— 追漫达人阿琳</p>
                </div>
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/70">
                  <div className="flex items-center gap-1 text-accent-500 mb-3">
                    {[1, 2, 3, 4, 5].map((i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                    "从第一话开始追到现在，每周期待更新已经成为习惯。感谢36漫画网提供这么好的平台！"
                  </p>
                  <p className="text-xs text-foreground-400">—— 老读者大刘</p>
                </div>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5 mt-6">
                <div className="p-4 rounded-lg bg-background-100 border border-background-200/70 text-center">
                  <p className="text-2xl font-bold text-primary-500">50万+</p>
                  <p className="text-xs text-foreground-500 mt-1">累计读者</p>
                </div>
                <div className="p-4 rounded-lg bg-background-100 border border-background-200/70 text-center">
                  <p className="text-2xl font-bold text-accent-500">99.5%</p>
                  <p className="text-xs text-foreground-500 mt-1">好评率</p>
                </div>
                <div className="p-4 rounded-lg bg-background-100 border border-background-200/70 text-center">
                  <p className="text-2xl font-bold text-primary-500">16+</p>
                  <p className="text-xs text-foreground-500 mt-1">精选作品</p>
                </div>
                <div className="p-4 rounded-lg bg-background-100 border border-background-200/70 text-center">
                  <p className="text-2xl font-bold text-accent-500">每日</p>
                  <p className="text-xs text-foreground-500 mt-1">稳定更新</p>
                </div>
              </div>
            </section>

            <section className="mb-14">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-900">
                  联系我们
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/70 flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                    <i className="ri-mail-line"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-foreground-800 mb-1">电子邮箱</h3>
                    <p className="text-sm text-foreground-500">contact@36manhua.com</p>
                    <p className="text-xs text-foreground-400 mt-1">商务合作 / 版权问题 / 意见建议</p>
                  </div>
                </div>
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/70 flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 flex-shrink-0">
                    <i className="ri-qq-line"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-foreground-800 mb-1">客服QQ</h3>
                    <p className="text-sm text-foreground-500">1234567890</p>
                    <p className="text-xs text-foreground-400 mt-1">在线客服 / 读者交流</p>
                  </div>
                </div>
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/70 flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 flex-shrink-0">
                    <i className="ri-time-line"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-foreground-800 mb-1">工作时间</h3>
                    <p className="text-sm text-foreground-500">周一至周五 9:00 - 18:00</p>
                    <p className="text-xs text-foreground-400 mt-1">法定节假日休息</p>
                  </div>
                </div>
                <div className="p-5 rounded-lg bg-background-100 border border-background-200/70 flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 flex-shrink-0">
                    <i className="ri-map-pin-line"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-foreground-800 mb-1">公司地址</h3>
                    <p className="text-sm text-foreground-500">北京市朝阳区创意文化产业园A座3层</p>
                    <p className="text-xs text-foreground-400 mt-1">36漫画网总部</p>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-500">
                  <i className="ri-question-answer-line text-lg"></i>
                </div>
                <h2 className="font-heading text-xl md:text-2xl text-foreground-900">
                  常见问题
                </h2>
              </div>
              <div className="space-y-3">
                <details className="group rounded-lg bg-background-100 border border-background-200/70 p-5 cursor-pointer">
                  <summary className="flex items-center justify-between text-sm font-medium text-foreground-800 list-none">
                    洞洞杂货铺漫画是免费的吗？
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
                    是的！36漫画网上的洞洞杂货铺漫画完全免费阅读，无需付费订阅。我们致力于为漫画爱好者提供优质的免费阅读体验。
                  </p>
                </details>
                <details className="group rounded-lg bg-background-100 border border-background-200/70 p-5 cursor-pointer">
                  <summary className="flex items-center justify-between text-sm font-medium text-foreground-800 list-none">
                    漫画多久更新一次？
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
                    洞洞杂货铺漫画保持每日更新，其他热门漫画也保持高频更新节奏。具体更新频率请关注各漫画的更新状态。
                  </p>
                </details>
                <details className="group rounded-lg bg-background-100 border border-background-200/70 p-5 cursor-pointer">
                  <summary className="flex items-center justify-between text-sm font-medium text-foreground-800 list-none">
                    阅读漫画需要注册账号吗？
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
                    不需要！36漫画网所有漫画均可免注册直接阅读，无需登录即可畅享全部内容。
                  </p>
                </details>
                <details className="group rounded-lg bg-background-100 border border-background-200/70 p-5 cursor-pointer">
                  <summary className="flex items-center justify-between text-sm font-medium text-foreground-800 list-none">
                    如何找到更多好看的漫画？
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
                    您可以通过首页的热门推荐、分类浏览功能发现更多漫画。我们涵盖热血、恋爱、搞笑、悬疑、奇幻、都市、武侠、科幻等多种类型，总有一部适合你！
                  </p>
                </details>
              </div>
            </section>
          </div>
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}